var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.htmlTag,{tag:"component",staticClass:"amui-headline",class:_vm.classes},[(_vm.text)?[_vm._v(" "+_vm._s(_vm.text)+" ")]:_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }